<template>
  <div>
    <vehicle-information></vehicle-information>
    <nav class="menu-background sticky-top">
      <Menu :category-list="categoryList" class="smaller-container-wrapper" />
    </nav>
    <div class="spotlight-inner-wrapper mt-4">
      <div class="smaller-container-wrapper">
        <router-view v-if="currentProduct" :product="currentProduct" :key="routerViewKey"></router-view>
        <other-products></other-products>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const VehicleInformation = () => import('@/modules/spotlight/components/categories/VehicleInformation.vue');
const Menu = () => import('@/modules/spotlight/components/HorizontalScrollBar.vue');
const OtherProducts = () => import('@/modules/spotlight/containers/OtherProducts.vue');

export default {
  name: 'ProductDetails',
  components: {
    VehicleInformation,
    Menu,
    OtherProducts,
  },
  computed: {
    ...mapGetters({
      getProductList: 'spotlight/getProductList',
      categories: 'spotlight/getSpotlightCategories',
    }),
    categoryList() {
      return [
        ...this.categories.map(value => ({
          name: value.category,
          value: value.category,
        })),
      ];
    },
    category() {
      return this.$route.meta.category;
    },
    currentProduct() {
      const pathArray = this.$route.path.split('/');
      // make sure that the last element of the path array exactly matches the product internalName.
      return this.getProductList(this.category).find(product =>
        pathArray.find(matched => matched.toLowerCase() === product.internalName.toLowerCase())
      );
    },
    routerViewKey() {
      return this.currentProduct?.name || 1;
    },
  },
};
</script>

<style scoped lang="scss">
@import 'src/assets/scss/variables';
.menu-background {
  background: $primary;
  top: 43px;
}

.spotlight-inner-wrapper {
  .smaller-container-wrapper {
    padding-bottom: 100px;

    h5 {
      margin-top: 40px;
      margin-bottom: 24px;
    }
  }
}
</style>
